export const TRANSFER_ORDER_TYPE = {
  RETURN: 1, // Đơn trả kết quả
  RECEIVE: 2, // Đơn nhận mẫu
};

export const OPTION_TRANSFER_ORDER_TYPE = [
  {
    value: TRANSFER_ORDER_TYPE.RECEIVE,
    label: "Nhận mẫu",
  },
  {
    value: TRANSFER_ORDER_TYPE.RETURN,
    label: "Trả kết quả",
  },
];

export const SHIPPING_TYPE = {
  RUNNER: 1, // Runner
  DVVC: 2, // DVVC
  NHAXE: 3, // Chành xe
};

export const TIME_SLOT_TYPE = {
  COORDINATE: 0, // Điều phối
  RUNNER: 1, // Runner
  DVVC: 2, // DVVC
  COLLECTOR: 3, // Collector
  BUS: 4, // Nhà xe
};

export const ORDER_TYPE_RECEIVE = {
  label: "Nhận hàng",
  value: 2,
};

export const ORDER_TYPE_RETURN = {
  label: "Trả kết quả",
  value: 1,
};

export const COLLECTOR = {
  label: "Nhận hàng",
  value: 2,
};

export const STATUS = {
  NEW: 1,
  COORDINATED: 2,
  RECEIVED: 3,
  DELIVERED: 4,
  DONE: 5,
  PENDING: 6,
  CANCEL: 7,
  HUB_ARRIVED: 8,
  TRANSFER: 9,
};

export const NOTE_REASON_TYPE = {
  HANDLE: 4,
  OF_CUSTOMER: 5,
  OF_ALLOCATE: 6,
};

export const ORDER_TYPE = {
  RETURN: {
    label: "Trả kết quả",
    value: 1,
  },
  RECEIVE: {
    label: "Nhận hàng",
    value: 2,
  },
  COLLECTOR: {
    label: "Lấy máu",
    value: 3,
  },
  BUS_RECEIVE: {
    label: "Lấy hàng nhà xe",
    value: 4,
  },
};

export const STATUS_FILTER_KEY = "status";

export const OPTION_ORDER_GROUP = [
  ORDER_TYPE.RETURN,
  ORDER_TYPE.RECEIVE,
  ORDER_TYPE.COLLECTOR,
  ORDER_TYPE.BUS_RECEIVE,
];

export const CREATE_MODE = {
  WITH_CHILDREN: 1, // Tạo đơn lấy hàng nhà xe có đơn con (mặc định)
  WITHOUT_CHILDREN: 2, // Tạo đơn lấy hàng nhà xe không có đơn con
};
